// extracted by mini-css-extract-plugin
module.exports = {"menuVerticalDivider":"menuVerticalDivider_2_0Po","iconSize":"iconSize_kkbt_"};